import React, { useState, useContext, useEffect } from 'react'
import { GoogleMap, InfoWindowF, Marker } from '@react-google-maps/api'
import { useSearchParams } from 'react-router-dom'
import { Context } from '../../contexts/Context'
import CurrLocationMarker from './CurrLocationMarker'
import InfoWindowContent from './InfoWindowContent'
import Directions from './Directions'
import _ from 'lodash'
import Sidebar from './Sidebar'
import WhatsappButton from './WhatsappButton'
import '../../styles.css'

let mapControl = true
if (window.innerWidth <= 520) mapControl = false
const mapOptions = { streetViewControl: false, clickableIcons: false, zoomControl: mapControl, mapTypeControl: mapControl }

export default function MapComponent () {
  const {
    getNearbyCenters,
    currLocation,
    handleClinicClick,
    selectedClinic,
    nearByCenters,
    handleCurrLocation,
    point,
    handlePoint,
    getLocationAddress
  } = useContext(Context)

  const [param, setParam] = useState(null)
  const [searchParams] = useSearchParams()
  const [zoom, setZoom] = useState(16)
  const [resultComponent, setResultComponent] = useState(false)
  const handleResultComponent = (status) => {
    setResultComponent(status)
  }

  if (searchParams.get('origin') && searchParams.get('centerId') && !param) {
    const origin = searchParams.get('origin').split(',').map(Number)
    const centerId = +searchParams.get('centerId')
    const locationstatus = searchParams.get('currentlocation') === 'true'
    setParam({
      origin: { lat: origin[0], lng: origin[1] },
      centerId,
      locationstatus
    })
  }

  const onMapLoad = React.useCallback(function callback (map) {
    const bounds = new window.google.maps.LatLngBounds()
    map.fitBounds(bounds)
    initLocation()
    // eslint-disable-next-line
  }, [])

  const handleZoom = (level) => {
    setZoom(level)
  }

  useEffect(() => {
    if (param && param.centerId && !_.isEmpty(nearByCenters)) {
      handleClinicClick(param.centerId)
    }
    // eslint-disable-next-line
  }, [nearByCenters])

  async function getCurrLocation () {
    if (param && param.origin) {
      await getNearbyCenters(param.origin)
      if (param.locationstatus) {
        handleCurrLocation(param.origin)
        getLocationAddress(param.origin)
      } else handlePoint(param.origin)
    } else {
      navigator?.geolocation.getCurrentPosition(
        ({ coords: { latitude: lat, longitude: lng } }) => {
          const location = { lat, lng }
          handleCurrLocation(location)
          getLocationAddress(location)
          getNearbyCenters(location)
        },
        () => window.alert('Please Allow location')
      )
    }
  }

  const trackLocation = ({ onSuccess, onError = () => {} }) => {
    if ('geolocation' in navigator === false) {
      return onError(
        new Error('Geolocation is not supported by your browser.')
      )
    }
    return navigator.geolocation.watchPosition(onSuccess, onError)
  }
  function initLocation () {
    trackLocation({
      onSuccess: ({ coords: { latitude: lat, longitude: lng } }) => {
        handleCurrLocation({ lat, lng })
        handleZoom(15)
      },
      onError: (err) => console.log({ Error: 'Allow location' || err.message })
    })
  }

  useEffect(() => {
    getCurrLocation()
    // eslint-disable-next-line
  }, [])

  return (
    <div className='App'>
      <Sidebar props={{ handleZoom, handleResultComponent, resultComponent, nearByCenters, currLocation, point }} />
      <div className={resultComponent ? 'map' : 'mobile-map map'}>
        <GoogleMap
          onLoad={(map) => onMapLoad(map)}
          center={point || currLocation}
          zoom={zoom}
          options={mapOptions}
        >
          {nearByCenters &&
            nearByCenters.map((center) => (
              <Marker
                key={+center.centerId}
                position={{ lat: center.location?.coordinates[1], lng: center.location?.coordinates[0] }}
                onClick={() => {
                  handleClinicClick(+center.centerId)
                  handleZoom(17)
                }}
              >
                {selectedClinic && selectedClinic === +center.centerId && (
                  <InfoWindowF position={{ lat: center.location?.coordinates[1], lng: center.location?.coordinates[0] }}>
                    <InfoWindowContent
                      center={center}
                      currLocation={point || currLocation}
                      handleClinicClick={handleClinicClick}
                    />
                  </InfoWindowF>
                )}
              </Marker>
            ))}
          <>
            {/* Current location Marker */}
            {currLocation && (
              <CurrLocationMarker
                props={{ position: currLocation, handleZoom, stroke: 10, scale: 12 }}
              />
            )}
            {/* Pointer Marker */}
            {point && (
              <CurrLocationMarker props={{ position: point, handleZoom, url: 'http://maps.google.com/mapfiles/ms/micons/green-dot.png', stroke: 0, scale: 0.1 }} />
            )}

            {!_.isEmpty(nearByCenters) && selectedClinic && (point || currLocation) && (
              <Directions
                origin={point || currLocation}
                centersList={nearByCenters}
                selectedClinic={selectedClinic}
              />
            )}
          </>
          <WhatsappButton resultComponent={resultComponent} />
        </GoogleMap>
      </div>

    </div>
  )
}
